import CurrentSelectedChamberSelectors from "../../reducers/current-selected-chamber-reducer";

/**
 * Specific shared services for IsolatorRow
 * Functions should be kept clean and pure, avoiding side effects or data mutation
 * @type {{validateOutletOverIsolator: (function(*, *, *): boolean), testSelectedChambersBeforeRemoval: (function(*, *): boolean), validateInternalOutletOnPerimeterRow(*, *, *): boolean, validateIsolatorOverOutlet: (function(*, *, *): boolean), validateSelectedChamberIsActive: (function(*, *): boolean), getActualRows: (function(*, *=, *=, *=, *=, *, *): *), handleManifoldBuildRestrictions: (function(*=, *=): null), removeSelectedChambers: (function(*, *, *): boolean), getChamberCapAccessory: (function(*=, *=, *): ({id: null}|*)), validateInnerFreeSpace: (function(*, *, *, *=, *): boolean), ignoreAccessoryAttachment: (function(*=, *): boolean)}}
 */
const IsolatorService = {
    hasIsolator: ( chamberRows, col, row ) => {
        try {
            const chamber = chamberRows[row]._chambers[col];
            return ( chamber && chamber._isIsolatorArray.length > 0 );
        } catch (error) {
            if (error.message !== "Cannot read properties of undefined (reading '_chambers')")
                console.error(`IsolatorService.hasIsolator() :: ${error.message}`);
            return false;
        }
    },

    /**
     * Generates the array to mark the chambers as isolator active
     * @param manifold
     * @param chamberBed {object} - chamberbed object.
     * @returns {[]}
     */
    calculateIsolatorRowArray: ( manifold, chamberBed ) => {
        let isolatorRowChambersArrayUpper = [];
        let isolatorRowChambersArrayLower = [];
        try {
            const { letRow, id: manifoldId, _hasSecondPipe: hasSecondPipe, _isUpper: isUpper } = manifold;

            const chamberRow_chambers = chamberBed.chamberRows[letRow]._chambers;
            const revChamberRow_chambers = [...chamberRow_chambers].reverse();

            let tempManifoldId = "";
            let tempManifoldIdOpposite = "";
            let firstActive = true;
            let secondActive = false;
            // let firstNotActive = true;
            let secondNotActive = false;
            let continueCount = false;

            for (const [index, chamber] of chamberRow_chambers.entries()) { // DONT REMOVE INDEX
                const accessory = manifold.isUpper
                    ? ( chamber._upperCapAccessory && chamber._upperCapAccessory.manifoldId === manifoldId ) ? chamber._upperCapAccessory : chamber._lowerCapAccessory
                    : ( chamber._lowerCapAccessory && chamber._lowerCapAccessory.manifoldId === manifoldId ) ? chamber._lowerCapAccessory : chamber._upperCapAccessory;
                tempManifoldId = manifoldId !== ( accessory || {} ).manifoldId && tempManifoldId.length && chamber.active ? tempManifoldId
                    : ( accessory ) ? accessory.manifoldId : ( chamber._active ) ? tempManifoldId : "";
                tempManifoldIdOpposite = manifoldId !== ( accessory || {} ).manifoldId && tempManifoldIdOpposite.length ? tempManifoldIdOpposite
                    : ( accessory ) ? accessory.manifoldId : tempManifoldIdOpposite;

                // Run on the main side of the manifold
                if (manifold.isUpper) {
                    if (tempManifoldId === manifoldId && isUpper && chamber._active) {
                        const coordinatesObject = {
                            manifoldId,
                            row: chamber._row,
                            col: chamber._col,
                        };
                        isolatorRowChambersArrayUpper.push(coordinatesObject);
                    }
                }
                if (!manifold.isUpper) { // THIS IS OK
                    // Run on the opposite side of a lower manifold if there is a second pipe
                    if (tempManifoldIdOpposite === manifoldId && !isUpper && hasSecondPipe) {
                        const coordinatesObject = {
                            manifoldId,
                            row: chamber._row,
                            col: chamber._col,
                        };
                        // STEP2
                        if (chamber._active && !firstActive && secondActive) {
                            continueCount = true;
                            // firstNotActive = false;
                            secondNotActive = true;
                        }

                        // STEP1
                        if (chamber._active && accessory && firstActive) {
                            firstActive = false;
                            secondActive = true;
                            continueCount = false;
                        }

                        // STEP3
                        if (!chamber._active && !firstActive && secondActive && secondNotActive) {
                            secondNotActive = true;
                            secondActive = false;
                            continueCount = false;
                        }

                        if (continueCount) {
                            isolatorRowChambersArrayUpper.push(coordinatesObject);
                        }
                    } else if (tempManifoldIdOpposite !== manifoldId && !isUpper && hasSecondPipe) {
                        if (accessory && ( accessory.id === "Outlet-Manifold" ))
                            isolatorRowChambersArrayUpper.push({
                                manifoldId,
                                row: chamber._row,
                                col: chamber._col,
                            });
                    }
                }
            }

            tempManifoldId = "";
            tempManifoldIdOpposite = "";
            firstActive = true;
            secondActive = false;
            // firstNotActive = true;
            secondNotActive = false;
            continueCount = false;

            for (const [index, chamberInverted] of revChamberRow_chambers.entries()) { // DONT REMOVE INDEX
                const accessory = manifold.isUpper
                    ? ( chamberInverted._upperCapAccessory ) ? chamberInverted._upperCapAccessory : chamberInverted._lowerCapAccessory
                    : ( chamberInverted._lowerCapAccessory ) ? chamberInverted._lowerCapAccessory : chamberInverted._upperCapAccessory;
                tempManifoldId = manifoldId !== ( accessory || {} ).manifoldId && tempManifoldId.length && chamberInverted.active ? tempManifoldId
                    : ( accessory ) ? accessory.manifoldId : ( chamberInverted._active ) ? tempManifoldId : "";
                tempManifoldIdOpposite = manifoldId !== ( accessory || {} ).manifoldId && tempManifoldIdOpposite.length ? tempManifoldIdOpposite
                    : ( accessory ) ? accessory.manifoldId : tempManifoldIdOpposite;

                // Run on the main side of the manifold
                if (!manifold.isUpper) {
                    if (tempManifoldId === manifoldId && !isUpper && chamberInverted._active) {
                        const coordinatesObject = {
                            manifoldId,
                            row: chamberInverted._row,
                            col: chamberInverted._col,
                        };
                        //console.log("UP ", coordinatesObject);
                        isolatorRowChambersArrayLower.push(coordinatesObject);
                    }
                }
                if (manifold.isUpper) {
                    if (tempManifoldIdOpposite === manifoldId && isUpper && hasSecondPipe) {
                        const coordinatesObject = {
                            manifoldId,
                            row: chamberInverted._row,
                            col: chamberInverted._col,
                        };
                        // STEP2
                        if (chamberInverted._active && !firstActive && secondActive) {
                            continueCount = true;
                            // firstNotActive = false;
                            secondNotActive = true;
                        }

                        // STEP1
                        if (chamberInverted._active && accessory && firstActive) {
                            firstActive = false;
                            secondActive = true;
                            continueCount = false;
                        }

                        // STEP3
                        if (!chamberInverted._active && !firstActive && secondActive && secondNotActive) {
                            secondNotActive = true;
                            secondActive = false;
                            continueCount = false;
                        }

                        if (continueCount) {
                            isolatorRowChambersArrayLower.push(coordinatesObject);
                        }
                    } else if (tempManifoldIdOpposite !== manifoldId && isUpper && hasSecondPipe) {
                        if (accessory && ( accessory.id === "Outlet-Manifold" )) {
                            isolatorRowChambersArrayLower.push({
                                manifoldId,
                                row: chamberInverted._row,
                                col: chamberInverted._col,
                            });
                        }
                    }
                }

            }
        } catch (e) {
            console.error(`At IsolatorService.calculateIsolatorRowArray() :: ${e.message}`);
        }
        return [...isolatorRowChambersArrayUpper, ...isolatorRowChambersArrayLower];
    },

    /**
     * Calls the action to set the array of chambers
     * @param chamberArray
     * @param manifoldId
     * @param actualRow
     * @param actualCol
     * @param props
     */
    setChambersIsolator: ( chamberArray, manifoldId, actualRow, actualCol, props ) => {
        try {
            props.modifyChambersByArrayIsolator(
                chamberArray,
                actualRow,
                actualCol,
                { isIsolatorArray: { manifoldId } },
            );
        } catch (exception) {
            console.error(`IsolatorService.setChambersIsolator() :: ${exception.message}`);
        }
    },


    testForTee: ( isolatorArray, props ) => {
        try {
            isolatorArray.forEach(chambermeta => {
                if (props.insertaTeeWarningType !== undefined && props.insertaTeeWarningType !== "MANIFOLD_CREATE") {
                    if (CurrentSelectedChamberSelectors.hasChamberTee(chambermeta.row, chambermeta.col)) {
                        console.log("chambermeta", chambermeta);
                        console.log("hasChamberTee", CurrentSelectedChamberSelectors.hasChamberTee(chambermeta.row, chambermeta.col));
                        props.setInsertaTeeWarningType("SETTING_ISO");
                        props.showInsertaTeeWarning(true);
                    }
                }
            });
        } catch (exception) {
            console.error(`IsolatorService.testForTee() :: ${exception.message}`);
        }
    },

    /**
     * Main function to calculate and mark isolator on a manifold
     * @param manifold
     * @param chamberbed
     * @param props
     */
    setIsolator: ( manifold, chamberbed, props ) => {
        try {
            const { id: manifoldId, letRow: row, letColumn: col } = manifold;
            if (manifold._isInlet === true && manifold._hasIsolator) {
                const isolatorArray = IsolatorService.calculateIsolatorRowArray(manifold, chamberbed);
                IsolatorService.testForTee(isolatorArray, props);
                IsolatorService
                    .setChambersIsolator(
                        isolatorArray,
                        manifoldId,
                        row,
                        col,
                        props,
                    );
            }
        } catch (exception) {
            console.error(`IsolatorService.setIsolator() :: ${exception.message}`);
        }
    },

    /**
     * Will calculate the array for a full row without a manifold
     * @param chamberBed
     * @param rowId
     * @returns {*[]}
     */
    calculateIsolatorSingleRowArray: ( rowId, row, chamberBed ) => {
        let isolatorRowChambersArray = [];
        try {
            const chamberArray = chamberBed.chamberRows[row]._chambers;

            for (const [index, chamber] of chamberArray.entries()) { // DONT REMOVE INDEX

                const coordinatesObject = {
                    rowId,
                    row: chamber._row,
                    col: chamber._col,
                };
                isolatorRowChambersArray.push(coordinatesObject);
            }
        } catch (exception) {
            console.error(`At IsolatorService.calculateIsolatorRowArray() :: ${exception.message}`);
        }
        return isolatorRowChambersArray;
    },

    /**
     * Calls the action to set the array of a row
     * @param rowId
     * @param rowArray
     * @param row
     * @param props
     */
    setSingleRowIsolator: ( rowId, rowArray, row, props ) => {
        try {
            props.modifyChambersByArrayIsolator(
                rowArray,
                row,
                0,
                { isIsolatorArray: { manifoldId: rowId } },
            );
        } catch (exception) {
            console.error(`ManifoldService.setChambersManifoldMetadata() :: ${exception.message}`);
        }
    },

    /**
     * TODO: might no be inuse any more
     * Secondary function to calculate and mark isolator on a single row
     * @param row
     * @param props
     */
    setRowIsolator: ( row, props ) => {
        const rowId = "row" + row;
        IsolatorService
            .setSingleRowIsolator(
                rowId,
                IsolatorService.calculateIsolatorSingleRowArray(rowId, row, props.chamberbed),
                row,
                props,
            );
    },

    /**
     *
     * @param {object} row The row to return quantity of chambers and endcaps that are isolators
     */
    getIsolatorQuantitiesForRow: ( row ) => {
        let isoChambers = 0;
        let isoEndcaps = 0;

        if (row && row.chambers) {
            row.chambers.forEach(c => {
                if (c.isIsolatorArray.length) {
                    isoChambers++;
                    if (c.upperCapActive) isoEndcaps++;
                    if (c.lowerCapActive) isoEndcaps++;
                }
            });
        }

        return { isoChambers, isoEndcaps };
    },
};

export default IsolatorService;



// WEBPACK FOOTER //
// ./src/lib/services/isolator_service.js